export function getFileNameFromDisposition(
    contentDisposition?: string,
): string | null {
    if (!contentDisposition) {
        return null;
    }

    const encodedFileName = contentDisposition.match(
        /filename\*=UTF-8''([^;]+)/i,
    );

    if (encodedFileName?.[1]) {
        return decodeURIComponent(encodedFileName[1]);
    }

    const plainFileName = contentDisposition.match(/filename="?([^"]+)"?/i);

    return plainFileName?.[1] ?? null;
}

export function downloadBlob(blob: Blob, fileName: string): void {
    const blobUrl = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');

    anchor.href = blobUrl;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(blobUrl);
}
